import { useContext, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import dialogContext, { DialogType } from "@utilities/contexts/dialogContext";
import DialogHeader from "@components/DialogBox/DialogHeader";

const ConfirmationDialog = () => {
    const {
        dialogType,
        showDialog,
        setShowDialog,
        title,
        content,
        color,
        verificationText,
        setVerificationText,
        okButtonTitle,
        cancelButtonTitle,
        onClickOk,
        onClickCancel,
    } = useContext(dialogContext);

    const [inputText, setInputText] = useState("");

    const handleClose = () => {
        resetData();
        setShowDialog(false);
    };

    const resetData = () => {
        setInputText("");
        setVerificationText("");
    };

    return (
        <Dialog open={showDialog} onClose={handleClose} PaperProps={{ sx: { maxHeight: "35%", minWidth: "30%", p: 0.5 } }}>
            <DialogHeader title={title} onClose={handleClose} />
            <DialogContent sx={{ pl: 2, pt: 0.5 }}>
                {content}
                {verificationText !== "" ? (
                    <Box pl={2} pr={4} pt={1}>
                        To confirm the operation type <b>{verificationText}</b> in the field.
                        <TextField
                            sx={{ pt: 1 }}
                            variant="outlined"
                            size="small"
                            fullWidth
                            placeholder={verificationText}
                            onChange={(e) => setInputText(e.target.value)}
                        ></TextField>
                    </Box>
                ) : null}
            </DialogContent>
            <DialogActions sx={{ pr: 2, pb: 1.75, pt: 2 }}>
                {dialogType === DialogType.CONFIRMATION ? (
                    <Button
                        sx={{ borderRadius: 0.5 }}
                        variant="outlined"
                        onClick={() => {
                            handleClose();
                            if (onClickCancel) onClickCancel();
                        }}
                        autoFocus
                    >
                        {cancelButtonTitle ? cancelButtonTitle : "No"}
                    </Button>
                ) : null}
                <Button
                    variant="contained"
                    sx={{ borderRadius: 0.5 }}
                    onClick={() => {
                        handleClose();
                        onClickOk();
                    }}
                    autoFocus
                    disabled={verificationText !== "" && verificationText !== inputText}
                    color={color}
                >
                    {okButtonTitle ? okButtonTitle : dialogType === DialogType.CONFIRMATION ? "Yes" : "OK"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
